// Export a class so `new LogoCenteredHeader()` works without errors.
export default class LogoCenteredHeader {
    constructor() {
        this.onResize = this.handleMenuOverlay.bind(this);

        // Run after DOM is ready and bind resize once.
        if (document.readyState === 'loading') {
            document.addEventListener(
                'DOMContentLoaded',
                () => {
                    this.handleMenuOverlay();
                    window.addEventListener('resize', this.onResize);
                },
                { once: true }
            );
        } else {
            this.handleMenuOverlay();
            window.addEventListener('resize', this.onResize);
        }
    }

    handleMenuOverlay() {
        const isMobileView = window.matchMedia('(max-width: 1000px)').matches;

        if (!isMobileView) {
            // (Optional) You could add cleanup here if you need to restore desktop state.
            return;
        }

        const leftMenuList = document.querySelector('[aria-label="Left Header Menu"] .wp-block-navigation__container');
        const rightMenuList = document.querySelector('[aria-label="Right Header Menu"] .wp-block-navigation__container');
        const combinedMenuContainer = document.querySelector('.wp-block-navigation__responsive-container-content');
        const rightMenuNav = document.querySelector('[aria-label="Right Header Menu"]'); // entire right menu
        const rightMenuButton = rightMenuNav?.querySelector('.wp-block-navigation__responsive-container-open'); // menu button
        const rightMenuModal = document.querySelector('#modal-2'); // modal
        const menuButton = document.querySelector('.wp-block-navigation__responsive-container-open');
        const closeButton = document.querySelector('.wp-block-navigation__responsive-container-close');
        const menuContainer = document.querySelector('.wp-block-navigation__responsive-container');

        // Build merged mobile menu only once per page load
        if (leftMenuList && rightMenuList && combinedMenuContainer && !combinedMenuContainer.dataset.lchCombined) {
            const combinedMenu = document.createElement('ul');
            combinedMenu.className = 'wp-block-navigation__container is-responsive wp-block-navigation';

            // Left items
            Array.from(leftMenuList.children).forEach((item) => {
                combinedMenu.appendChild(item.cloneNode(true));
            });

            // Right items
            Array.from(rightMenuList.children).forEach((item) => {
                combinedMenu.appendChild(item.cloneNode(true));
            });

            // Insert into mobile container
            combinedMenuContainer.innerHTML = '';
            combinedMenuContainer.appendChild(combinedMenu);
            combinedMenuContainer.dataset.lchCombined = '1';
        }

        // Remove right nav (mobile only)
        if (rightMenuNav) rightMenuNav.remove();
        if (rightMenuButton) rightMenuButton.remove();
        if (rightMenuModal) rightMenuModal.remove();

        // Bind open/close handlers only once
        if (menuButton && closeButton && menuContainer && !menuContainer.dataset.lchBound) {
            menuButton.addEventListener('click', function (event) {
                event.preventDefault();
                menuContainer.classList.add('is-menu-open');
                document.body.style.overflow = 'hidden';
            });

            closeButton.addEventListener('click', function (event) {
                event.preventDefault();
                menuContainer.classList.remove('is-menu-open');
                document.body.style.overflow = '';
            });

            // Close when clicking outside the menu (on the overlay)
            menuContainer.addEventListener('click', function (event) {
                if (event.target === menuContainer) {
                    menuContainer.classList.remove('is-menu-open');
                    document.body.style.overflow = '';
                }
            });

            menuContainer.dataset.lchBound = '1';
        }
    }
}
